<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('log')"
      :columns="columns"
      :column_search="false"
      :extra_data="{ directory: $route.params.directory }"
      resource_url="/script/log/datatables"
    />
  </div>
  <details-modal ref="details_modal" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date_time,
} from "@/utils";
import DetailsModal from "./details_modal/Index.vue";

export default {
  name: "ScriptLogsDatatable",
  components: { GenericTable, DetailsModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          data: (row) => {
            return format_date_time(row.create_date);
          },
        },
        {
          title: v.$t("status"),
          data: (row) => {
            return v.translate_status(row.status_code);
          },
        },
        {
          title: v.$t("arguments"),
          data: (row) => {
            let lsts = Object.keys(row.arguments).map((key) => {
              return { name: key, value: row.arguments[key] };
            });

            return lsts
              .map((arg) => {
                return `${arg.name}: ${arg.value}`;
              })
              .join(", ");
          },
        },
        // {
        //   title: v.$t("result"),
        //   data: (row) => {
        //     return `<pre>${row.result}</pre>`;
        //   },
        // },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-primary",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.details_modal.show_modal(row.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete log?"),
                    v,
                    () => {
                      del("/script/log", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    translate_status(status_code) {
      let v = this;
      switch (status_code) {
        case "N":
          return v.$t("new");
        case "R":
          return v.$t("running");
        case "F":
          return v.$t("finished");
        case "X":
          return v.$t("errored");
        default:
          return status_code;
      }
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
